import { render, staticRenderFns } from "./download_grades.vue?vue&type=template&id=d2ef4236&scoped=true&"
import script from "./download_grades.vue?vue&type=script&lang=ts&"
export * from "./download_grades.vue?vue&type=script&lang=ts&"
import style0 from "./download_grades.vue?vue&type=style&index=0&id=d2ef4236&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ef4236",
  null
  
)

export default component.exports